import { useHistory } from "react-router-dom"
import { Button, Card, Col, Divider, List, Popconfirm, Row, message } from "antd"
import axios from "axios"
import { useContext } from "react"
import { OrderContext } from "../Context/OrderContext"
import { ThemeContext } from "../Context/ThemeContext"
import { UserContext } from "../Context/UserContext"
import { DeleteOutlined } from "@ant-design/icons"

function ShopCart(){
    let history = useHistory()
    const [user,,,setDashboard] = useContext(UserContext) 
    const [theme] = useContext(ThemeContext)
    const [userOrder,,loading] = useContext(OrderContext)

    setDashboard(false)

    let orderItem = userOrder[0]?.order_item

    let totalBarang = 0
    orderItem?.map(function(item){
        return totalBarang+=item.quantity
    })
    let totalHarga = 0
    orderItem?.map(function(item){
        return totalHarga+=item.product.price
    })
    
    const HandleBuy = () => {    
        history.push(`/payment`)
    }
      
    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''
    
    return(
        <>
        <Divider className={changeNameClass} orientation="center" style={{fontSize: "30px"}}>
            YOUR ORDER
        </Divider>
        <div style={{marginTop: "50px"}}>
            <Row>
                <Col span={17}>
                <List
                grid = {{column: 1}}
                loading={loading}
                dataSource={orderItem}
                renderItem={el => (
                    <List.Item>
                        <Card className={changeNameClass} style={{borderRadius: "15px"}}>
                            <Row>
                                <Col span={3}>
                                    <img src={`${el.product.image}`} 
                                    style={{maxHeight:"80px", width:"auto"}}
                                    alt="gambar produk"></img>
                                </Col>
                                <Col span={17}>
                                    <h3>{el.product.name}</h3>
                                    <h4>Jumlah barang: {el.quantity}</h4>
                                    <h4>Total harga: {el.quantity*el.product.price}</h4>
                                </Col>
                                <Col span={4} style={{padding: "20px"}}>
                                    <Popconfirm
                                        title="Are you sure to delete this product?"
                                        onConfirm={(e) => {
                                            console.log(el)
                                            axios.delete(`https://backend-sportyan.vercel.app/api/item/order/${el.id}`, {headers: {"Authorization" : "Bearer "+ user.token}})
                                            .then((res) => {
                                                window.location.reload()
                                                console.log(res)
                                                message.success('Data has been deleted successfully')
                                            })
                                        }}
                                        // onCancel={cancel}
                                        okText="Yes"
                                        cancelText="No"
                                        >
                                        <Button type="danger">
                                            <DeleteOutlined style={{fontSize: "20px"}} />
                                        </Button>
                                    </Popconfirm>
                                </Col>
                            </Row>

                        </Card>

                    </List.Item>
                    )}
                />
                </Col>
                <Col span={1}></Col>
                <Col span={6}>
                    <Card>
                        <h3>Ringkasan Belanja</h3>
                        <Row>
                            <Col span={14}>Total Barang : <br/>Total Harga : </Col>
                            <Col span={10} style={{textAlign: "right"}}> {totalBarang} <br/> Rp. {totalHarga}</Col>
                        </Row>
                    </Card>
                    <Row style={{marginTop: "20px"}}>
                        <Col span={8}></Col>
                        <Col>
                            <Button size="large" type="primary" onClick={HandleBuy}>
                                Bayar
                            </Button>
                        </Col>
                        <Col span={8}></Col>
                    </Row>
                </Col>
            </Row>

        </div>
        </>
    )
}

export default ShopCart